var map = {
	"./coopdk.png": "7648",
	"./coopmad.png": "fd16",
	"./daglibrugsen.png": "2080",
	"./fakta.png": "8f51",
	"./faktaq.png": "bd4b",
	"./grønland.png": "ef7a",
	"./irma.png": "a357",
	"./kvickly.png": "15d1",
	"./logo.png": "cf05",
	"./superbrugsen.png": "8160"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";